var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStationCluster(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 12 24.151",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".i-cluster-icon{fill:inherit}.i-cluster-icon-path{stroke:currentColor}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 .75)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 21.347)",
    "data-name": "Gruppe 27406"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Gruppe 27405"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "i-cluster-icon",
    cx: 0.685,
    cy: 0.685,
    r: 0.685,
    "data-name": "Ellipse 2034"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(4.627 20.663)",
    "data-name": "Gruppe 27408"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Gruppe 27407"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "i-cluster-icon",
    cx: 1.369,
    cy: 1.369,
    r: 1.369,
    "data-name": "Ellipse 2035"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(10.631 21.347)",
    "data-name": "Gruppe 27410"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Gruppe 27409"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "i-cluster-icon",
    cx: 0.685,
    cy: 0.685,
    r: 0.685,
    "data-name": "Ellipse 2036"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(4.113 2.897)",
    "data-name": "Gruppe 27412"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Gruppe 27411"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "i-cluster-icon",
    cx: 1.883,
    cy: 1.883,
    r: 1.883,
    "data-name": "Ellipse 2037"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.436)",
    "data-name": "Gruppe 27414"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Gruppe 27413"
  }, /*#__PURE__*/React.createElement("path", {
    className: "i-cluster-icon-path",
    transform: "translate(-625.49 -552.41)",
    d: "m630 552.41h-4.508v13.527a4.509 4.509 0 0 0 9.018 0v-9.018a4.514 4.514 0 0 0-4.51-4.509z",
    fill: "none",
    strokeMiterlimit: 10,
    strokeWidth: "1.5px",
    "data-name": "Pfad 13956"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStationCluster);
export default __webpack_public_path__ + "static/media/stationCluster.e262c02f945a3eaff86d7c808708258d.svg";
export { ForwardRef as ReactComponent };